import Http from './http';
import { colleagueCacheTTL } from 'Config';
import store from 'store';

class ColleaguesService {
    constructor() {
        this.colleagues = null;
        // var intervalID = setInterval(()=>{
        //     this.resetCache()
        // }, colleagueCacheTTL);
    }

    resetCache(){
        this.colleagues = null;
        store.set('colleagues', false);
        this.getColleagues();
    }

    getColleagues() {
        return new Promise((resolve, reject) => {
            if (store.get('colleagues', false)){
                this.colleagues = store.get('colleagues');
            }
            if (this.colleagues) resolve(this.colleagues);
            else {
                Http.get('/colleagues/').then(resp => {
                    this.colleagues = resp.data;
                    store.set('colleagues', this.colleagues);
                    resolve(resp.data);
                });
            }
        })
    }
}

export default new ColleaguesService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/colleagues.js